const SDK_VERSION = '7.33.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
